import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type PermissionsExpandToggleProps = {
  isExpanded: boolean;
  remainingCount: number;
  hasMore: boolean;
  onToggle: () => void;
  fullWidth?: boolean;
  className?: string;
  dataTestId?: string;
};

export const PermissionsExpandToggle = ({
  isExpanded,
  remainingCount,
  hasMore,
  onToggle,
  fullWidth = true,
  className,
  dataTestId = "toggle-permissions",
}: PermissionsExpandToggleProps) => {
  if (!hasMore) {
    return null;
  }

  return (
    <ThemedButton
      className={cnTwMerge("justify-center text-text/interactive", className)}
      dataTestId={dataTestId}
      fullWidth={fullWidth}
      onClick={onToggle}
      variant="tertiary"
    >
      {isExpanded
        ? m.userManagement_permissions_seeLess()
        : m.userManagement_permissions_seeMore({ count: remainingCount })}
    </ThemedButton>
  );
};
